import { DIET_TYPE_ENABLED_FOR_ALL } from '../../../utils/featureFlags';
import { useLeaderIsB2B } from './useLeaderIsB2B.hook';
/**
 * Check centralizzato per l'abilitazione del "tipo di alimentazione" (dietType).
 *
 * È l'unico punto da cui passa il gating del dietType in tutti i flussi
 * (onboarding del leader, creazione membro, modifica da profilo): così, per
 * rendere la feature disponibile a tutti gli utenti, basta flippare il flag
 * `DIET_TYPE_ENABLED_FOR_ALL` in un solo posto.
 *
 * - flag `true`  ⇒ abilitato per tutti gli utenti (anche non-B2B)
 * - flag `false` ⇒ abilitato solo per gli utenti B2B
 */
export var useIsDietTypeEnabled = function () {
    var isB2B = useLeaderIsB2B();
    return DIET_TYPE_ENABLED_FOR_ALL || isB2B;
};
